<template>
  <el-card style="max-width: 100%;">
    <template #header>
      <slot name="up"></slot>
    </template>
    <slot></slot>
  </el-card>
</template>
